// extracted by mini-css-extract-plugin
module.exports = {"main-gallery":"_9e1425b4d3--main-gallery--U2vV5"};